import React,{useEffect, useState,useContext} from 'react'
import axios from 'axios'


function Contact() {

  const [userData, setUserData] = useState({name:"", email:"", phone:"", message:""})
  
  const callContact = async () =>{
    
    try {
      const res = await fetch('/getdata',{
      method:"GET",
      headers:{
        "Content-Type":"application/json"
      },
    });
    const data = await res.json();
    console.log(data);
    setUserData({...setUserData, name:data.name,email:data.email,phone:data.phone});
    if(!res.status ===200){
      const error = new Error(res.error);
      throw error;
    }
  } catch (error) {
    console.log(error);
  }
  
}

useEffect(() => {
  callContact();
}, [])
const handleClick = (e) =>{
const  name = e.target.name;
  const value = e.target.value;

  setUserData(values => ({...values, [name]: value}))

}

const contactForm = async (e) =>{
  e.preventDefault();

  const {name,email,phone,message} = userData
  axios.post("/contact",userData)
  .then(()=>{
    console.log("Message Sent");
    window.alert("Message Sent");
    setUserData({...userData, message:""})
  })
  .catch((e)=>{console.log("Message Not Sent"+e)})
}

return (
  <>
      <div style={{minHeight: "100vh"}} className='contact_info bg-light'>
        <div className='container-fluid pb-5'>
          <div className='col-lg-10 offset-lg-1'>
            <div className='row pt-5 mx-auto'>
                <div className='col-lg-4 p-1 '>
                  <div className='rounded border bg-white py-2'>
                    <div className='d-flex flex-row align-items-center'>
                      <div className='flex-start p-2 mx-2'>
                        <i className='fa fa-2x fa-phone text-primary'></i>
                      </div>
                      <div className='flex-end'>
                        <h5>Phone</h5>
                        <small className='text-muted' >+92 304 9345139</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-4 p-1 '>
                  <div className='rounded border bg-white py-2'>
                    <div className='d-flex flex-row align-items-center'>
                      <div className='flex-start p-2 mx-2'>
                        <i className='fa fa-2x fa-envelope text-primary'></i>
                      </div>
                      <div className='flex-end ml-2'>
                        <h5>Email</h5>
                        <small className='text-muted' >info@uamcodes.com</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-4 p-1 '>
                  <div className='rounded border bg-white py-2'>
                    <div className='d-flex flex-row align-items-center'>
                      <div className='flex-start p-2 mx-2'>
                        <i className='fa fa-2x fa-map-marker text-primary'></i>
                      </div>
                      <div className='flex-end ml-2'>
                        <h5>Address</h5>
                        <small className='text-muted'>Qasim Bela, Multan Cantt</small>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div className='container my-5 bg-white border mx-auto  rounded p-5'>
          <div className='signin-content '>
            <div className='signin-form'>
              <h2>Get In Touch</h2>
              <div className='row pt-2'>
                  <div className='col-lg-12 my-auto'>
                  <form method='POST'>
  <div class="form-group row">
    <div class="col-lg-4 my-2">
      <input type="name" class="form-control" name='name' id="name" value={userData.name}
      
      onChange={handleClick}
       placeholder='Your Name'/>
    </div>
    <div class="col-lg-4 my-2">
      <input type="email" class="form-control" name='email' id="email" value={userData.email}
      
      onChange={handleClick}
       placeholder='Your Email'/>
    </div>
    <div class="col-lg-4 my-2">
      <input type="number" class="form-control" name='phone' id="phone" value={userData.phone}
      
      onChange={handleClick}
       placeholder='Your Phone'/>
    </div>
    </div>
    <div class="form-group">
    <textarea class="form-control" id="message" name='message' value={userData.message}
    
    onChange={handleClick}
     placeholder='Your Message' rows="5"></textarea>
  </div>
  <div class="form-group row">
    <div class="col-sm-12 btn-group btn-group-justified">
      <button type="submit" onClick={contactForm} class="btn btn-justified btn-dark">Send Message</button>
    </div>
  </div>
</form>
                  </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </>
  )
}

export default Contact